import { CButton } from "@app/components/Common";
import { COLORS } from "@app/constants";
import React, {useContext} from "react";
import { useTranslation } from "react-i18next";
import { View } from "@/styles/reactnative";
import { useTradeSetting } from "../../../../../../hooks/trade/tradeSetting";
import {useMobileDimensions} from "@app/hooks";
import {ThemeContext} from "@/theme/ThemeProvider.tsx";

interface IProps {
  cross_iso: string;
  leverage: number;
  ep_id: number;
  closeModal?: () => void;
  handleConfirm?: () => void;
}

const CrossModalFooter = ({
  cross_iso,
  leverage,
  ep_id,
  closeModal,handleConfirm
}: IProps) => {
  const { t } = useTranslation();
  const { mutate: mutateTradeSetting } = useTradeSetting(ep_id);
  const { isMobile } = useMobileDimensions();
  const { borderColor, textw } = useContext(ThemeContext).theme.COLORS;

  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        marginTop: isMobile ? 30 : 18,
        position: "relative",
      }}
    >
      <CButton
        title={t("confirm")}
        style={{
          flex: 1,
          padding: 10,
          background: COLORS.primary,
          marginRight: 10,
          color: COLORS.white,
          borderRadius: 4,
          cursor: "pointer",
        }}
        onClick={() => {
          mutateTradeSetting({ leverage, cross_iso }, ep_id);
          closeModal && closeModal();

          // if(handleConfirm) {
          //   handleConfirm();
          // } else {
          //   mutateTradeSetting({ leverage, cross_iso }, ep_id);
          //   closeModal && closeModal();
          // }
        }}
      />
      <CButton
        title={t("cancel")}
        style={{
          flex: 1,
          padding: 10,
          background: 'transparent',
          color: textw,
          borderRadius: 4,
          border: `1px solid ${borderColor}`,
          cursor: "pointer",
        }}
        onClick={() => {
          closeModal && closeModal();
        }}
      />
    </View>
  );
};

export default CrossModalFooter;
